<template>
  <div>
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3" :titleMsg4="titleMsg4"></TitleCard>
    <a-modal v-model="geoshow"  >
      <MapGeo @mapgeoEvent="SaveMapEvent"  :keyWord="address"></MapGeo>
    </a-modal>
    <a-card class="all-card-style ">

      <a-form-model :model="scene"  :rules="sceneFormRules" ref="scene"   :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" >

        <a-row>
          <a-col :span="8">
            <a-form-model-item label="企业ID"  class="ant-form-item2 " >
              <a-input  v-model="scene.cEntID" placeholder="" :disabled="true" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="项目"  class="ant-form-item2 " >
              <a-select
                placeholder=""
                v-model="scene.cPlatformID"   class="ant-form-item3 "
              >
                <a-select-option :value="item.ID"  v-for="(item,index) in PlatformList" >
                  {{item.cPlatformName}}
                </a-select-option>

              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="模板ID"  class="ant-form-item2 " >
              <a-input v-model="scene.cSceneTempID" placeholder="请输入模板ID"  />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="场地编码"  prop="cSceneCode"  class="ant-form-item2 " >
              <a-input v-model="scene.cSceneCode"  placeholder="请输入场地编码"   />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="场地名称"  prop="cSceneName"  class="ant-form-item2 " >
              <a-input label="cSceneName"  v-model="scene.cSceneName" placeholder="请输入场地名称"   />

            </a-form-model-item>

          </a-col>

          <a-col :span="8">
            <a-form-model-item label="详细地址" prop="cAddress"  class="ant-form-item2 " >
<!--              <a-input   placeholder="请输入详细地址"   />-->
              <a-input-search
                placeholder="请输入详细地址"
                enter-button
                @search="toMapPage(scene.cAddress)"
                v-model="scene.cAddress"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="纬度"  prop="cLatitude"  class="ant-form-item2 " >
              <a-input v-model="scene.cLatitude"  placeholder="请输入场地经度"  />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="经度" prop="cLongitude"   class="ant-form-item2 " >
              <a-input v-model="scene.cLongitude"  placeholder="请输入纬度"    />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="面积" prop="cArea"  class="ant-form-item2 "  >
              <a-input v-model="scene.cArea"  placeholder="请输入面积"   />
            </a-form-model-item>
          </a-col>

          <a-col :span="8">
            <a-form-model-item label="负责人"  class="ant-form-item2 " >

              <a-select
                placeholder=""
                v-model="scene.cChargeUser"
                @change="changeCharge"   class="ant-form-item3 "
              >
                <a-select-option  :value="item.ID" v-for="(item,index) in userList" >
                  {{item.cUserName}}
                </a-select-option>

              </a-select>

            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="负责人手机"  class="ant-form-item2 " >
              <a-input v-model="scene.cChargeMoblie" placeholder="请输入负责人手机"  />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="负责人邮箱"  class="ant-form-item2 " >
              <a-input v-model="scene.cChargeEmail" placeholder="请输入负责人邮箱"  />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="备注"  class="ant-form-item2 " >
              <a-input v-model="scene.Remark" placeholder="请输入备注"  />
            </a-form-model-item>
          </a-col>

          <a-col :span="8">
            <a-form-model-item label="省/市/区"  class="ant-form-item2 " >
              <!--              <a-input v-model="EntInfo.cEntCountry" placeholder="请输入" />-->
              <a-cascader :options="options" v-model="dfi" placeholder="请选择" @change="onChange"   class="ant-form-item2 " />
            </a-form-model-item>
          </a-col>


        </a-row>


        <a-form-model-item :wrapper-col="{ span: 12, offset: 2 }">
          <a-button type="primary" html-type="button" @click="SaveForms">
            确定
          </a-button>

        </a-form-model-item>

      </a-form-model>


    </a-card>
  </div>
</template>

<script>
  import TitleCard from '@/components/TitleCard.vue'
import MapGeo from '@/components/MapGeo'
  export default {
    name: 'sceneManagementForm',
    components: {
      TitleCard,
      MapGeo
    },
    data() {
      return {
        options:[],
        dfi:['110000','110100','110101'],
        sceneFormRules:{

          cSceneCode:
            [
            { required: true, message: '请输入场地编码', trigger: 'blur' }
          ],
          cSceneName: [
            { required: true, message: '请输入场地名称', trigger: 'blur' }
            ],
          cAddress:[
            { required: true, message: '请输入详细地址', trigger: 'blur' }
          ],
          cLatitude:[
            { required: true, message: '请输入纬度', trigger: 'blur' }
          ],
          cLongitude:[
            { required: true, message: '请输入经度', trigger: 'blur' }
          ],

          cArea:[
            { required: true, message: '请输入面积', trigger: 'blur' }
          ],

        },
        titleMsg1: "设备管理",
        titleMsg2:'场地管理',
        titleMsg3:'场地管理',
        titleMsg4:'新增',
        scene:{
          ID:"",
          cEntID:"",
          cPlatformID:"",
          cSceneTempID:"",
          cSceneCode:"",
          cSceneName:"",
          cAddress:"",
          cLatitude:"",
          cLongitude:"",
          cArea:"",
          cUnit:"",
          cVariety:"",
          cChargeUser:"",
          cChargeMoblie:"",
          cChargeEmail:"",
          iDelete:"",
          cCreateUserID:"",
          cCreateUserName:"",
          dCreateDate:"",
          cUpdateUserID:"",
          cUpdateUserName:"",
          Remark:""
        },
        cVarietyClass:"",
        unitList:[],
        varietyList:[],
        userList:[],
        varietyclassList:[],
        PlatformList:[],
        PlatformCurrent:{},
        address:"",
        geoshow:false

      }
    },
    mounted () {
      let that=this;
      that.scene.cEntID=that.$store.getters.User.enterprise.ID;
      console.log('that.$route.params.ID',that.$route.params.ID);
      if (that.$route.params.ID){
        that.scene.ID=that.$route.params.ID;
        that.HandleDetail();
      }
try{   that.dfi=[ that.scene.cEntCountry+'', that.scene.cEntCity+'', that.scene.cEntArea+''];}catch (e) {

}



      that.handleunit();
      that.handlusers();
      that.handlearieaclass();
      that.handlePageList();
    },
    methods: {
      async HandleDetail () {
        var that = this;

        let res = await that.$http.post('EntSceneInfo/FindById/' + that.scene.ID, null)

        if (res.data.code == "200") {
          that.scene = res.data.obj.data;

          that.dfi=[ that.scene.cEntCountry+'', that.scene.cEntCity+'', that.scene.cEntArea+''];
          console.log('  that.dfi',  that.dfi);


        } else {

        }
      },
      onChange(_value){
        console.log('_value',_value);
        this.scene    .cEntCountry= _value[0];
        this.scene    .cEntCity=  _value[1];
        this.scene    .cEntArea=  _value[2];
      },
      SaveMapEvent(data){
        let that=this;
        that.scene.cLongitude=data.longitude;
        that.scene.cLatitude=data.latitude;
      that.geoshow=false;
      },
      changeCharge(){
        let that=this;
       let u= that.userList.filter(s=>s.ID==that.scene.cChargeUser)[0];
      if(u){
        that.scene.cChargeUser=u.cUserName;
        that.scene.cChargeMoblie=u.cMobile;
        that.scene.cChargeEmail=u.cEmail
      }

      },
      async handlePageList(){
        let that=this;


        let param={cEntID:that.scene.cEntID,cSystemCode:'节水灌溉'};
        let res= await that.$http.post('EntPlatformInfo/List',param)

        if(res.data.code=="200"){

          that.PlatformList= res.data.obj.list;
          that.scene.cPlatformID=that.PlatformList[0].ID;


        }
        else{
          that.$message.error(res.message)

        }
      },
      //单位
      async handleunit(){

        let that=this;
        let resArea=await  that.$http.post("/Enterprise/GetAreaJSON",{});
        that.options=eval(resArea.data.obj);

        let param={dicClassCode:'Unit'};

        let res= await that.$http.post('Dictionary/List',param)

        if(res.data.code=="200"){

          that.unitList=res.data.obj.list;

        }
        else{
          that.$message.error(res.message)

        }
      },
      async handleclasschange(){
        this.handleariea();
      },
      //节水灌溉
      async handleariea(){

        let that=this;


        let param={dicClassCode:that.cVarietyClass};

        let res= await that.$http.post('Dictionary/List',param)

        if(res.data.code=="200"){

          that.varietyList= res.data.obj.list;

        }
        else{
          that.$message.error(res.message)

        }
      },
      //获取用户列表
      async handlusers(){

        let that=this;

        let res= await that.$http.post('User/ListBySystem',{cEntID:that.scene.cEntID,cSystemCode:'节水灌溉'})


        if(res.data.code=="200"){

          that.userList= res.data.obj.list;
        }

      },
      //节水灌溉分类
      async handlearieaclass(){

        let that=this;


        let param={parentDicClassCode:'Tailbreed'};

        let res= await that.$http.post('DictionaryClass/List',param)


        if(res.data.code=="200"){

          that.varietyclassList= res.data.obj.list;

          that.cVarietyClass= that.varietyclassList[0].cDicClassCode;
          that.handleariea();

        }
        else{
          that.$message.error(res.message)

        }
      },
      toMapPage(record){
        let that=this;
        that.geoshow=true;

        that.address=record;
      },

      async SaveForms () {
        let that = this;
        let form=that.$refs['scene'];
        form.validate(async valid => {

          if (valid) {
            let res = await that.$http.post('EntSceneInfo/Save', that.scene)
            if (res.data.code == "200") {
              that.$message.success('保存成功!')
              that.$router.push({name:'sceneManagementList'});
            } else {
              that.$message.error(res.data.message)

            }
          } else {
            that.$message.error('校验失败!')
          }
        });
      }
    }

  }
</script>


